import React from 'react';

const styles = {
  container: {
    backgroundColor: '#ffffff',
    minHeight: '100vh',
    padding: '80px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontFamily: '"Inter", sans-serif',
    color: '#333',
  },
  header: {
    textAlign: 'center',
    marginBottom: '60px',
    maxWidth: '700px',
  },
  title: {
    fontSize: '3rem',
    fontWeight: '900',
    marginBottom: '10px',
    color: '#333',
    letterSpacing: '-1px',
  },
  subtitle: {
    fontSize: '1.2rem',
    color: '#666',
    lineHeight: '1.6',
  },
  // GRID LAYOUT
  grid: {
    width: '100%',
    maxWidth: '900px',
    display: 'grid',
    gap: '30px',
  },
  // JOB CARD
  card: {
    border: '1px solid #eaeaea',
    borderRadius: '12px',
    padding: '30px',
    backgroundColor: '#f9f9f9',
    transition: 'transform 0.2s, box-shadow 0.2s',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  roleTitle: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '5px',
  },
  tagContainer: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
  },
  tag: {
    fontSize: '0.85rem',
    fontWeight: 'bold',
    padding: '5px 12px',
    borderRadius: '20px',
    backgroundColor: '#e0e0e0',
    color: '#555',
    textTransform: 'uppercase',
  },
  activeTag: {
    backgroundColor: '#d1fae5', // Light Green
    color: '#065f46', // Dark Green
  },
  description: {
    fontSize: '1rem',
    lineHeight: '1.6',
    color: '#555',
  },
  requirementsTitle: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    marginTop: '10px',
    color: '#333',
  },
  list: {
    paddingLeft: '20px',
    margin: '0',
    color: '#555',
  },
  listItem: {
    marginBottom: '5px',
  },
  applyButton: {
    marginTop: '15px',
    alignSelf: 'flex-start',
    padding: '12px 30px',
    backgroundColor: '#333',
    color: '#fff',
    textDecoration: 'none',
    fontWeight: 'bold',
    borderRadius: '6px',
    fontSize: '1rem',
    transition: 'background 0.2s',
  },
  // NO OPENINGS MESSAGE
  emptyState: {
    textAlign: 'center',
    padding: '50px',
    backgroundColor: '#f9f9f9',
    borderRadius: '12px',
    color: '#888',
  }
};

export default function JobsPage() {
  return (
    <div style={styles.container}>
      
      <div style={styles.header}>
        <h1 style={styles.title}>Work With Us</h1>
        <p style={styles.subtitle}>
          Foreplay Games is an independent studio dedicated to high-quality adult narratives. 
          We are currently looking for <b>Freelance</b> talent to help bring our characters to life.
        </p>
        <p style={styles.subtitle}>
          <span style={{ color: 'red' }}>NOTE: YOU MUST BE 18 YEARS OF AGE OR OLDER TO WORK WITH US! NON-NEGOTIABLE!</span>
        </p>
      </div>

      <div style={styles.grid}>

        {/* --- JOB LISTING 1: VOICE ACTRESS --- */}
        <div style={styles.card}>
          <div>
            <h2 style={styles.roleTitle}>Voice Actress (Female)</h2>
            <div style={styles.tagContainer}>
              <span style={{...styles.tag, ...styles.activeTag}}>Open</span>
              <span style={styles.tag}>Freelance / Contract</span>
              <span style={styles.tag}>Remote</span>
            </div>
          </div>

          <p style={styles.description}>
            We are casting for multiple roles in <b>3XRay</b>, as well as a few roles for <b>LonelyHands</b>. We need versatile actors capable of delivering emotional depth 
            as well as handling NSFW/suggestive scenes with confidence.
          </p>

          <div>
            <h3 style={styles.requirementsTitle}>Requirements:</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>Professional home recording setup (XLR preferred, low noise floor).</li>
              <li style={styles.listItem}>Ability to perform "efforts" (breaths, sighs, reactions) naturally.</li>
              <li style={styles.listItem}>Comfortable with 18+ themes (Sexual content, romance).</li>
              <li style={styles.listItem}>Turnaround time of 1-2 weeks per batch.</li>
            </ul>
          </div>

          {/* LINK TO GOOGLE FORM OR EMAIL */}
          <a 
            href="mailto:jobs@foreplaygames.dev?subject=Voice Acting Application - [Name]" 
            style={styles.applyButton}
          >
            Apply via Email
          </a>
        </div>

        {/* --- JOB LISTING 4: VOICE ACTOR (MALE) --- */}
        <div style={styles.card}>
          <div>
            <h2 style={styles.roleTitle}>Voice Actor (Male)</h2>
            <div style={styles.tagContainer}>
              <span style={{...styles.tag, ...styles.activeTag}}>Open</span>
              <span style={styles.tag}>Freelance / Contract</span>
              <span style={styles.tag}>Remote</span>
            </div>
          </div>

          <p style={styles.description}>
            We are casting for male roles in our upcoming desktop-simulation RPG, <b>LonelyHands</b>. 
            We are looking for grounded, naturalistic performances to bring our stressed college students, 
            roommates, overbearing managers, etc.... to life! We need voices that feel real and conversational.
          </p>

          <div>
            <h3 style={styles.requirementsTitle}>Requirements:</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>Professional home recording setup (XLR preferred, low noise floor).</li>
              <li style={styles.listItem}>Ability to deliver natural, conversational dialogue (more "indie drama," less "anime over-the-top").</li>
              <li style={styles.listItem}>Comfortable with 18+ themes, mature language, and suggestive contexts.</li>
              <li style={styles.listItem}>Turnaround time of 1-2 weeks per batch.</li>
            </ul>
          </div>

          {/* LINK TO EMAIL */}
          <a 
            href="mailto:jobs@foreplaygames.dev?subject=Male Voice Acting Application - [Name]" 
            style={styles.applyButton}
          >
            Apply via Email
          </a>
        </div>

        {/* --- JOB LISTING 2: MUSIC COMPOSER --- */}
        <div style={styles.card}>
          <div>
            <h2 style={styles.roleTitle}>Music Composer</h2>
            <div style={styles.tagContainer}>
              <span style={{...styles.tag, backgroundColor: '#d1fae5', color: '#065f46'}}>Open</span>
              <span style={styles.tag}>Freelance / Contract</span>
              <span style={styles.tag}>Remote</span>
            </div>
          </div>

          <p style={styles.description}>
            We are looking for a composer to create the original soundtrack for <b>3XRay</b>. 
            The game requires a mix of "Slice of Life" (University vibes), tense "Investigation" tracks, 
            and distinct character themes.
          </p>

          <div>
            <h3 style={styles.requirementsTitle}>Requirements:</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>Strong portfolio demonstrating ability to match specific moods.</li>
              <li style={styles.listItem}>Experience creating seamless loops for game audio.</li>
              <li style={styles.listItem}>Ability to create distinct "Leitmotifs" for main characters.</li>
              <li style={styles.listItem}>Comfortable with 18+ context (some tracks may be for intimate scenes).</li>
            </ul>
          </div>

          <a 
            href="mailto:jobs@foreplaygames.dev?subject=Composer Application - [Name]" 
            style={{
              marginTop: '15px',
              alignSelf: 'flex-start',
              padding: '12px 30px',
              backgroundColor: '#333',
              color: '#fff',
              textDecoration: 'none',
              fontWeight: 'bold',
              borderRadius: '6px',
              fontSize: '1rem',
              display: 'inline-block'
            }}
          >
            Apply via Email
          </a>
        </div>

        {/* --- JOB LISTING 3: 2D ARTIST / UI DESIGNER --- */}
        <div style={styles.card}>
          <div>
            <h2 style={styles.roleTitle}>2D Artist / UI Designer</h2>
            <div style={styles.tagContainer}>
              <span style={{...styles.tag, backgroundColor: '#d1fae5', color: '#065f46'}}>Open</span>
              <span style={styles.tag}>Freelance / Contract</span>
              <span style={styles.tag}>Remote</span>
            </div>
          </div>

          <p style={styles.description}>
            We are looking for a versatile 2D Digital Artist & UI Designer to help define the visual identity of Foreplay Games. 
            While we utilize AI-assisted workflows for some character art, we need a skilled human hand to design the crucial 
            elements AI struggles with: sharp game logos, studio branding, and bespoke UI assets (buttons, menus, meters, and icons).
          </p>

          <div>
            <h3 style={styles.requirementsTitle}>Requirements:</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>Strong portfolio showcasing UI/UX design specifically for video games.</li>
              <li style={styles.listItem}>Experience creating clean, readable graphic design, typography, and logos.</li>
              <li style={styles.listItem}>Ability to match distinct styles (e.g., sleek/modern for <em>3XRay</em>, retro/desktop for <em>LonelyHands</em>).</li>
              <li style={styles.listItem}>Bonus: Experience with pixel art or 2D skeletal animation (Spine/Live2D).</li>
              <li style={styles.listItem}>Comfortable working in an 18+ adult indie studio environment.</li>
            </ul>
          </div>

          <a 
            href="mailto:jobs@foreplaygames.dev?subject=2D Artist / UI Designer Application - [Name]" 
            style={{
              marginTop: '15px',
              alignSelf: 'flex-start',
              padding: '12px 30px',
              backgroundColor: '#333',
              color: '#fff',
              textDecoration: 'none',
              fontWeight: 'bold',
              borderRadius: '6px',
              fontSize: '1rem',
              display: 'inline-block'
            }}
          >
            Apply via Email
          </a>
        </div>

        {/* --- JOB LISTING 3: 2D ARTIST (FILLED) --- */}
        <div style={{...styles.card, opacity: 0.9, border: '1px solid #ddd'}}> 
          <div>
            <h2 style={styles.roleTitle}>2D Artist / AI Retouch Specialist</h2>
            <div style={styles.tagContainer}>
              {/* "Filled" Tag */}
              <span style={{...styles.tag, backgroundColor: '#e0e0e0', color: '#555'}}>Filled</span>
              <span style={styles.tag}>Freelance / Contract</span>
              <span style={styles.tag}>Remote</span>
            </div>
          </div>

          <p style={styles.description}>
            We use generative tools to create base assets, but we rely on skilled human artists to finalize them. 
            This role focuses on correcting anatomy (hands, limbs), fixing artifacts, repainting details, and 
            compositing characters into scenes to ensure visual consistency.
          </p>

          <div>
             <h3 style={styles.requirementsTitle}>Typical Requirements:</h3>
             <ul style={styles.list}>
                <li style={styles.listItem}>Strong understanding of anatomy (essential for fixing AI errors).</li>
                <li style={styles.listItem}>Proficiency in Photoshop/Clip Studio Paint for seamless overpainting.</li>
                <li style={styles.listItem}>Ability to color grade and match character lighting to backgrounds.</li>
             </ul>
          </div>

          {/* Status Message instead of Apply Button */}
          <div style={{
              marginTop: '20px',
              padding: '15px',
              backgroundColor: '#f0f0f5',
              borderRadius: '8px',
              color: '#666',
              fontSize: '0.95rem',
              fontStyle: 'italic',
              borderLeft: '4px solid #888'
          }}>
            Status: <b>Position Currently Filled.</b> We are not accepting new applications at this time, 
            but may open additional slots as production ramps up.
          </div>
        </div>

      </div>

    </div>
  );
}